import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import http from '@/assets/api/http';
import EditableTagGroup from './components/EditableTagGroup';
import { Modal } from 'antd';
import { GoodsTagTypeEnum as ge, ArticleCategory as ac } from './types';
import { connect } from 'react-redux';
import { setBreadcrumbPaths } from '@/reducers/home/actions';

const fixedProps = {
    [ac.CATEGORY]: {
        /** 固定标签不可删除 */
        fixedTags: ['其他'],
        inputProps: {
            placeholder: '请输入品类名称'
        }
    },
    [ac.PRICE]: {
        inputProps: {
            placeholder: '请输入价值标签，例:50~100元'
        }
    },
    [ac.HELP_BUG_REMAEK]: {
        inputProps: {
            placeholder: '请输入备注名称'
        }
    }
};

const Article = (props) => {

    const [categoryList, setCategoryList] = useState([]);
    const [editItem, setEditItem] = useState(null);
    useEffect(() => {
        props.setBreadcrumbPaths(props.match); // 自动识别面包屑
    }, []);

    function saveInfo(id, type, info) {
        if (info) {
            http('/?cmd=com.xqxc.api.pig.mis.biz.user.CuGoodsTagInfoMisService.saveTagInfo', { id, type, info }).then(res => {
                if (res.errCode === 0) {
                    console.log(res);
                }
            });

            let item = categoryList.find(v => v.category === type);
            item.data = info;
            setCategoryList(categoryList.concat());
        }

        setEditItem(null);
    }

    function enterEdit(categoryName) {
        if (editItem) {
            Modal.confirm({
                title: '温馨提示',
                content: (
                    <div key='fe'>
                        <div style={{ fontSize: 16 }}><strong>{editItem}</strong>编辑未保存，是否开始<strong>{categoryName}</strong>编辑？</div>
                        <div style={{ fontSize: 14, color: '#808080' }}>更新的内容不会自动保存</div>
                    </div>
                ),
                onOk: () => setEditItem(categoryName)
            });
        } else {
            setEditItem(categoryName);
        }
    }

    useEffect(() => {
        http('/?cmd=com.xqxc.api.pig.mis.biz.user.CuGoodsTagInfoMisService.list').then(res => {
            if (res.errCode === 0) {
                let list = (res.result || {}).info || [];
                let cates = ge.map(e => {
                    let target = (list.find(v => e.code === v.type) || { info: [] });
                    return {
                        category: e.code,
                        categoryName: e.value,
                        data: target.info,
                        id: target.id
                    };
                });
                setCategoryList(cates);
            }
        });
    }, []);

    return (
        <div className={styles.container}>
            {categoryList.map((v, i) => <EditableTagGroup key={i} visible={editItem === v.categoryName} onEnterEdit={enterEdit} onLeaveEdit={saveInfo} {...fixedProps[v.category]} {...v} />)}
        </div>
    );
};

Article.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object, // 路由match对象
    setBreadcrumbPaths: PropTypes.func,
};

export default connect(null, { setBreadcrumbPaths })(Article);
